export const siteInfo = {
  name: "爆料专区",
  tagline: "匿名爆料 · 热点线索 · 社区互动",
  description:
    "爆料专区是一个面向普通网友的匿名爆料与社区互动平台。你可以匿名投稿身边的新鲜事与独家线索，也能在评论区参与热议、留言互动，让你的声音被更多人看到。",
  email: "baoliao@example.com",
  slogan: "你的见闻，值得被更多人看见",
};

export const communityStats = [
  { label: "累计爆料", value: "12,846", unit: "条", icon: "ri-megaphone-line" },
  { label: "今日新增", value: "217", unit: "条", icon: "ri-add-circle-line" },
  { label: "评论互动", value: "58,392", unit: "次", icon: "ri-chat-smile-2-line" },
  { label: "活跃爆料人", value: "3,409", unit: "位", icon: "ri-user-heart-line" },
];

export const faqList = [
  {
    q: "在爆料专区投稿需要实名吗？",
    a: "不需要。投稿全程支持匿名，你只需填写一个化名即可发布。若你希望我们后续与你核实线索，可以自愿留下联系方式，我们不会公开。",
  },
  {
    q: "投稿之后多久会被发布出来？",
    a: "工作时段内的投稿通常会在 24 小时内完成初步整理。涉及需要核实的线索，编辑会先联系投稿人补充细节，确认后再发布。",
  },
  {
    q: "评论区留言会显示我的身份吗？",
    a: "评论区同样支持匿名昵称。留言内容对所有访客可见，但不会展示账号信息、设备信息或 IP 归属地以外的个人资料。",
  },
  {
    q: "哪些内容不会被发布？",
    a: "涉及他人隐私、真实姓名与住址、未经证实的指控、商业广告以及法律法规禁止的内容，均不会通过审核。",
  },
  {
    q: "我可以要求删除自己发布的内容吗？",
    a: "可以。通过私信通道提供投稿时使用的化名与大致时间，我们核实后会尽快处理删除或修改请求。",
  },
  {
    q: "私信通道和投稿表单有什么区别？",
    a: "投稿表单适合结构完整的长线索；私信通道更适合补充材料、提供图片线索或与编辑沟通细节，两者都可以匿名使用。",
  },
];

export const testimonials = [
  {
    name: "阿岚",
    role: "爆料人 · 城市身边事",
    avatar: "ri-user-3-line",
    text: "本来只是随手写了小区食堂的事，没想到评论区一下子热闹起来，大家都在补充自己小区的情况，感觉特别真实。",
  },
  {
    name: "老周",
    role: "常驻读者 · 消费观察",
    avatar: "ri-user-star-line",
    text: "我最喜欢看消费观察这个栏目，很多坑都是别人先踩过、写出来我才能避开。评论区也常常有人补上更细的对比。",
  },
  {
    name: "小满",
    role: "爆料人 · 校园故事",
    avatar: "ri-user-smile-line",
    text: "匿名投稿让我很安心，整段过程都不用露脸。编辑回复也很快，问得很细，能感觉到是真的想把事情讲清楚。",
  },
];

export const submitSteps = [
  {
    title: "写出你看到的",
    desc: "用大白话说清楚时间、地点和经过，不需要文采，细节比修辞更重要。",
    icon: "ri-edit-2-line",
  },
  {
    title: "选一个分类",
    desc: "从六个主题里挑最贴近的一个，方便其他人在广场里找到你的内容。",
    icon: "ri-price-tag-3-line",
  },
  {
    title: "匿名提交",
    desc: "填一个化名就行。想被联系的话可以留邮箱，这条信息不会公开展示。",
    icon: "ri-lock-2-line",
  },
  {
    title: "等待整理发布",
    desc: "编辑会核实关键细节，必要时通过私信通道与你确认，然后安排发布。",
    icon: "ri-send-plane-line",
  },
];

export const contentPrinciples = [
  {
    title: "真实优先",
    desc: "只发布投稿人亲身经历或亲眼所见的内容，不做二次演绎，也不替投稿人下定论。",
    icon: "ri-shield-check-line",
  },
  {
    title: "保护当事人",
    desc: "我们会隐去不必要的真实姓名、具体住址与联系方式，避免给普通人带来困扰。",
    icon: "ri-lock-password-line",
  },
  {
    title: "让讨论有价值",
    desc: "评论区鼓励补充信息与理性交流，低质量的攻击与刷屏会被清理。",
    icon: "ri-discuss-line",
  },
];

export const footerGroups = [
  {
    title: "逛一逛",
    links: [
      { label: "首页", to: "/" },
      { label: "爆料广场", to: "/feed" },
      { label: "本周热榜", to: "/feed" },
    ],
  },
  {
    title: "参与进来",
    links: [
      { label: "我要爆料", to: "/submit" },
      { label: "投稿须知", to: "/submit" },
      { label: "关于我们", to: "/about" },
    ],
  },
  {
    title: "主题分类",
    links: [
      { label: "城市身边事", to: "/feed?category=city" },
      { label: "消费观察", to: "/feed?category=consumer" },
      { label: "热点追踪", to: "/feed?category=trend" },
    ],
  },
];